import {
  Card, CardBody, Center, Image, Stack, Text,
} from "@chakra-ui/react";
import { Heading22 } from "components/Heading";

interface EmptyProps {
  image: { src: string; alt?: string };
  heading: string;
  body?: string;
}

export default function Empty({ image, heading, body = undefined }: EmptyProps) {
  return (
    <Center>
      <Card maxWidth="700px">
        <CardBody>
          <Stack p="16">
            <Center>
              <Heading22>{heading}</Heading22>
            </Center>
            {body && (
              <Center>
                <Text fontSize="lg">{body}</Text>
              </Center>
            )}
            <Center>
              <Image maxHeight="300px" {...image} />
            </Center>
          </Stack>
        </CardBody>
      </Card>
    </Center>
  );
}
